import { useEffect, useMemo, useState } from "react";
import Document from "../../../../assets/Document.png";
import {
  getAllElectionTypes,
  getHasVotedElection,
} from "../../../../redux/action/election";
import { Link } from "react-router-dom";
import { handleRequestErrors } from "../../../../shared/utils";

interface ElectionType {
  electypeUniqueId: string;
  isOpen: boolean;
  justConcluded: boolean;
  name: string;
  isAllStudent: boolean;
  isIndigeneOnly: boolean;
  isFaculty: boolean;
  isDepartment: boolean;
  facultyName: string;
  departmentName: string;
}

const ActiveElections = () => {
  const [allElectionTypes, setAllElectionTypes] = useState<ElectionType[]>([]);
  const [electionStatus, setElectionStatus] = useState([]);

  let loggedAccountInfo: any = localStorage.getItem("stuXAuth") || "{}";
  loggedAccountInfo = JSON.parse(loggedAccountInfo);
  const studentInfo = loggedAccountInfo?.profile || {};
  const studentFaculty = studentInfo?.faculty || "";
  const studentDepartment = studentInfo?.department || "";

  const isIndigene =
    studentInfo?.state?.toLowerCase() === "nig" ||
    studentInfo?.state?.toLowerCase() === "niger";
  const studentUniqueId = studentInfo?.studentUniqueId || "";

  useEffect(() => {
    let isMounted = true;
    const fetchElectionTypes = async () => {
      try {
        if (studentUniqueId){
        const response = await getAllElectionTypes();
        if (!isMounted) return;
        if (response.status === 200) {
          const allTypes = response.data || [];
          setAllElectionTypes(allTypes);

          const filtered = allTypes.filter((election: ElectionType) => {
            if (
              election.isFaculty &&
              election.facultyName === studentFaculty &&
              (election.isOpen || election.justConcluded)
            )
              return true;

            if (
              election.isDepartment &&
              election.departmentName === studentDepartment &&
              (election.isOpen || election.justConcluded)
            )
              return true;

            if (
              election.isIndigeneOnly &&
              isIndigene &&
              (election.isOpen || election.justConcluded)
            )
              return true;

            if (
              election.isAllStudent &&
              (election.isOpen || election.justConcluded)
            )
              return true;

            return false;
          });

          const electionTypes = filtered.map((e: any) => e.name);

          if (allTypes && electionTypes.length > 0) {
            const response2 = await getHasVotedElection(
              electionTypes,
              studentUniqueId
            );
            setElectionStatus(response2.data || []);
          }
        }
      }} catch (error) {
        if (!isMounted) return;
        handleRequestErrors(error);
      } finally {
      }
    };

    fetchElectionTypes();
    return () => {
      isMounted = false;
    };
  }, [studentFaculty, studentDepartment, isIndigene, studentUniqueId]);

  const activeElections = useMemo(() => {
  return allElectionTypes.filter((election) => {
    if (
      election.isFaculty &&
      election.facultyName === studentFaculty &&
      (election.isOpen || election.justConcluded)
    )
      return true;

    if (
      election.isDepartment &&
      election.departmentName === studentDepartment &&
      (election.isOpen || election.justConcluded)
    )
      return true;

    if (
      election.isIndigeneOnly &&
      isIndigene &&
      (election.isOpen || election.justConcluded)
    )
      return true;

    if (election.isAllStudent && (election.isOpen || election.justConcluded))
      return true;

    return false;
  });
}, [allElectionTypes, studentFaculty, studentDepartment, isIndigene]);

  return (
    <>
      {activeElections.map((election) => {
        const candidateHasVoted = electionStatus.some(
          (status: any) =>
            status.electionType === election.name && status.hasVoted
        );

        return (
          <div className="each_item" key={election.electypeUniqueId}>
            <div className="item_heading">
              <div className="item_icon">
                <img src={Document} alt="Icon for election" />
              </div>
              <div className="item_title">{election.name} ELECTION</div>
            </div>
            <div className="item_content">
              <div className="item_desc">
                {candidateHasVoted && !election?.justConcluded
                  ? "You have voted for this election"
                  : election?.justConcluded
                  ? "Election closed"
                  : "Click here to vote"}
              </div>
              {!candidateHasVoted && !election?.justConcluded &&
          (    <div className="item_link">
                <Link
                  to= "/undergraduate/election/voting"
                  state={{ electionType: election.name }}
                >
                   Vote 🗳️
                </Link>
              </div>)
      }
            </div>
          </div>
        );
      })}
    </>
  );
};

export default ActiveElections;
